import { useQuery } from "@tanstack/react-query";
import { chatApi } from "../../api/chat";
import { GetChatsPayload, JoinAChatRoomPayload } from "../../types";
import { CheckRoomAdminBody, GetMemberConfirmationPayload, GetResourceInRoomBody } from "../../types/chat";

export const useGetChats = (body: GetChatsPayload) => {
  return useQuery({
    queryKey: ["get-chats", body],
    queryFn: () => chatApi.getChats(body),
  });
};

export const useJoinAChatRoom = (body: JoinAChatRoomPayload) => {
  return useQuery({
    queryKey: ["join-a-chat-room", body],
    queryFn: () => chatApi.joinAChatRoom(body),
    enabled: !!body.roomId,
  });
};

export const useCheckListUserInRoomAdmin = (body: { roomId: string; userIds: string[] }) => {
  return useQuery({
    queryKey: ["check-list-user-in-room-admin", body],
    queryFn: () => chatApi.checkListUserInRoomAdmin(body.userIds, body.roomId),
    enabled: !!body.roomId && body.userIds.length > 0,
  });
};

export const useCheckRoomAdmin = (body: CheckRoomAdminBody) => {
  return useQuery({
    queryKey: ["check-room-admin", body],
    queryFn: () => chatApi.checkRoomAdmin(body),
    enabled: !!body.roomId && !!body.userId,
  });
};

export const useGetResourceInRoom = (body: GetResourceInRoomBody) => {
  return useQuery({
    queryKey: ["get-resource-in-room", body],
    queryFn: () => chatApi.getResourceInRoom(body),
    enabled: !!body.type,
  });
};

export const useGetMemberConfirmation = (body: GetMemberConfirmationPayload, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ["get-member-confirmation", body],
    queryFn: () => chatApi.getMemberConfirmation(body),
    enabled: (options?.enabled ?? true) && !!body.roomId && !!body.messageId,
    staleTime: 0, // Always fetch fresh data
  });
};
